import { Component } from '@angular/core';
import { NotificationService } from '@app/services/notifications.service';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { ColumnDealStandardWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/column-deal-standard-wrapper.component';


@Component({
  selector: 'app-column-deal-standard-desktop',
  templateUrl: './column-deal-standard-desktop.component.html',
  styleUrls: ['./column-deal-standard-desktop.component.scss'],
})
export class ColumnDealStandardDesktopComponent extends ColumnDealStandardWrapperComponent {
  constructor(notification: NotificationService, route: ActivatedRoute, menuService: MenusServices) {
    super(route, menuService, notification);
  }
}
